"use client";

import Script from "next/script";

export function GTMManualScript() {
  return (
    <>
      {/* GTM: load immediately to maximize data capture — the INP defer
           will be reinstated once analytics data is confirmed healthy.
           The container (GTM-PJR2VDH) gates its ad tags on the OneTrust consent
           signal but sends no `consent default`, so the signal can land after
           tags have started. Mirrors the comment in pages/_document.tsx. */}
      <Script
        id="gtm-tag"
        dangerouslySetInnerHTML={{
          __html: `(function() {
            var loaded = false;
            function loadGTM() {
              if (loaded) return;
              if (window.location.pathname === '/search-modal' || (typeof URLSearchParams !== 'undefined' ? new URLSearchParams(window.location.search).get('gtm') === 'no' : window.location.search === '?gtm=no')) return;
              loaded = true;
              (function (w, d, s, l) {
                w[l] = w[l] || [];
                w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
                w.isGtmSetByApplication = 'TRUE';
                var isDirectvStream = /https:\\/\\/.*directvstream\\.com/.test(w.location.origin || "");
                var isDirectTv = /https:\\/\\/.*directv\\.com/.test(w.location.origin || "");
                var isDirectvDeals = /https:\\/\\/.*directvdeals\\.com/.test(w.location.origin || "");
                var isFinalStage = /https:\\/\\/finalstage\\.directv\\.com|https:\\/\\/stage\\.streamtv\\.directv\\.com|https:\\/\\/stage\\.directv\\.com/.test(w.location.origin || "");
                var gtmValues = { prodId: (isDirectTv || isDirectvDeals) ? "cvrSnbSB4i9EeyExvYzmrg" : isFinalStage ? "_W4ixasIEwfXSzppGw9u7Q" : "QlepJHnfbmh2CmmLBX9VMw", gtmPreview: (isDirectTv || isDirectvDeals) ? "env-1" : isFinalStage ? "env-26" : "env-25" };
                w.gtmValues = gtmValues;
                var i = isDirectvStream ? "GTM-MNB626R" : "GTM-PJR2VDH";
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l !== "dataLayer" ? "&l=" + l : "";
                j.async = true;
                j.src = isDirectvStream
                  ? "https://www.googletagmanager.com/gtm.js?id=" + i + dl
                  : "https://www.googletagmanager.com/gtm.js?id=" + i + dl + "&gtm_auth=" + gtmValues.prodId + "&gtm_preview=" + gtmValues.gtmPreview + "&gtm_cookies_win=x";
                f.parentNode.insertBefore(j, f);
              })(window, document, "script", "dataLayer");
            }
            loadGTM();
          })();`
        }}
      />
    </>
  );
}

export default GTMManualScript;
